import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../colorVars';
import IncrementButton from '../../buttons/incrementButton/IncrementButton';
import NumberInputWithUnit from '../numberInputWithUnit/NumberInputWithUnit';
import Tag from '../tagInput/Tag';
import style from './DualValueListInput.module.css';

const DualValueListInputClean = ({
  symbol1,
  symbol2,
  direction1,
  direction2,
  currentValues,
  currentValuesMappingFn,
  onAddFn,
  onDeleteFn,
}) => {
  const [valueList, setValueList] = useState([]);
  const [inputVal1, setInputVal1] = useState('');
  const [inputVal2, setInputVal2] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    setValueList(currentValues?.map(currentValuesMappingFn) || []);
  }, [currentValues]);

  const addToList = () => {
    if (inputVal1 === '' || inputVal2 === '') {
      setError(true);
    } else {
      setError(false);
      onAddFn(inputVal1, inputVal2);
    }
  };
  const removeFromList = (index) => {
    onDeleteFn(index);
  };

  return (
    <div className={style.container}>
      <div>
        {valueList.map((obj, index) => {
          const value = Object.values(obj);
          return (
            <Tag
              key={value + index + ''}
              closeHandler={(index) => {
                removeFromList(index);
              }}
              index={index}
            >
              {direction1 === 'left' &&
                direction2 === 'left' &&
                `${symbol1 + value[0]} | ${symbol2 + value[1]}`}
              {direction1 === 'right' &&
                direction2 === 'left' &&
                `${value[0] + symbol1} | ${symbol2 + value[1]}`}
              {direction1 === 'left' &&
                direction2 === 'right' &&
                `${symbol1 + value[0]} | ${value[1] + symbol2}`}
              {direction1 === 'right' &&
                direction2 === 'right' &&
                `${value[0] + symbol1} | ${value[1] + symbol2}`}
            </Tag>
          );
        })}
      </div>
      <p style={{ fontSize: '8px', color: 'red' }}>
        {error ? 'Missing field' : ''}
      </p>
      <div className={style.inputs}>
        <NumberInputWithUnit
          inputWidth="5em"
          value={inputVal1}
          setValue={setInputVal1}
          onBlur={() => {}}
          direction={direction1}
        >
          {symbol1}
        </NumberInputWithUnit>
        <span style={{ fontSize: '16px', margin: '0 3px' }}> | </span>
        <NumberInputWithUnit
          inputWidth="5em"
          margin="0 0 0 0"
          value={inputVal2}
          setValue={setInputVal2}
          onBlur={() => {}}
          direction={direction2}
        >
          {symbol2}
        </NumberInputWithUnit>

        <IncrementButton
          disabled={false}
          buttonWidth="18px"
          borderRadius="50%"
          width={10}
          stroke={2}
          color={colors.lightGrey}
          backgroundColor={valueList.length === 0 ? colors.red : colors.blue}
          paddingPercent={20}
          handleClick={addToList}
        />
      </div>
      <p
        className={style.note}
        style={{ color: valueList.length === 0 ? colors.red : colors.blue }}
      >
        Click <strong>+</strong> to add a value pair.
      </p>
    </div>
  );
};

DualValueListInputClean.propTypes = {
  currentValues: PropTypes.array,
  currentValuesMappingFn: PropTypes.any,
  direction1: PropTypes.string,
  direction2: PropTypes.string,
  onAddFn: PropTypes.func,
  onDeleteFn: PropTypes.func,
  symbol1: PropTypes.any,
  symbol2: PropTypes.any
};



export default DualValueListInputClean;


